// Be Bold - Year 2 Programme Data
// 52 weeks: Mastery I (1-13), Mastery II (14-26), Mastery III (27-40), Mastery IV (41-52)
// Deload weeks: 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 43, 47, 50
// Level 2 is the minimum active depth for every exercise in Year 2.
// 3 Rings: Ring 1 (outer, Level 1, 0-3cm), Ring 2 (middle, Level 2, 3-6cm), Ring 3 (inner, Level 3, 6-10cm)
// 3 Planes: Vertical (up/down), Lateral (left/right), Sagittal (front/back)

export const YEAR2_WEEKS = [

  // -- MASTERY I: Single-Plane Mastery at All Depths ------------------

  {
    week: 1, year: 2,
    theme: 'Year 2 Entry: Level 2 Is the New Floor',
    theme_pt: 'Entrada Ano 2: Nivel 2 e o Novo Chao',
    plane: 'vertical',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#9B4D7E',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 12 },
    push: { hold: 8, reps: 8 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
    exercises: ['vibracao', 'ordenha_full', 'succao'],
    appNote: 'Year 2 begins where Year 1 ended. Level 2 is now the starting point for every exercise. If anything feels easy, you are doing it right.',
    appNote_pt: 'O Ano 2 comeca onde o Ano 1 terminou. O Nivel 2 e agora o ponto de partida de cada exercicio. Se algo parecer facil, voce esta fazendo certo.',
  },

  {
    week: 2, year: 2,
    theme: 'Vertical Plane: Isometric at Level 3 (Target 15s)',
    theme_pt: 'Plano Vertical: Isometrico no Nivel 3 (Meta 15s)',
    plane: 'vertical',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false,
    newMovement: 'Deep Isometric', newMovement_pt: 'Isometrico Profundo',
    freq: 5, color: '#9B4D7E',
    zone: 'Full floor 6-10cm', zone_pt: 'Assoalho completo 6-10cm',
    position: 'sitting',
    squeeze: { hold: 15, sets: 5, reps: 1 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 6 },
    isometricTarget: 15,
    milestone: null,
    skillBadge: 'Isometric Hold at Level 3: 15 seconds',
    skillBadge_pt: 'Hold Isometrico no Nivel 3: 15 segundos',
    exercises: ['isometrico_l3'],
    planeNote: 'VERTICAL PLANE. SQUEEZE held at Level 3 without moving. Target this week: 15 seconds without depth retreat. Build to 30 seconds by week 13.',
    planeNote_pt: 'PLANO VERTICAL. APERTAR mantido no Nivel 3 sem se mover. Meta desta semana: 15 segundos sem perder a profundidade. Construa ate 30 segundos na semana 13.',
    appNote: 'SQUEEZE at Level 3. Hold for 15 seconds. Do not let depth retreat. Do not hold your breath. Record your time and add 2 to 3 seconds each week.',
    appNote_pt: 'APERTAR no Nivel 3. Segurar por 15 segundos. Nao deixe a profundidade recuar. Nao prenda a respiracao. Registre seu tempo e adicione 2 a 3 segundos por semana.',
  },

  {
    week: 3, year: 2,
    theme: 'Vertical Plane: Eccentric Descent from Level 3',
    theme_pt: 'Plano Vertical: Descida Excentrica do Nivel 3',
    plane: 'vertical',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false,
    newMovement: 'Eccentric Deep', newMovement_pt: 'Excentrico Profundo',
    freq: 5, color: '#9B4D7E',
    zone: 'Full floor 6-10cm', zone_pt: 'Assoalho completo 6-10cm',
    position: 'sitting',
    squeeze: { hold: 15, sets: 2, reps: 6 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    pushRule: 'eccentric_8count',
    eccentricWeek: true,
    milestone: null,
    skillBadge: 'Eccentric descent from Level 3',
    skillBadge_pt: 'Descida excentrica do Nivel 3',
    exercises: ['eccentric_deep'],
    planeNote: 'VERTICAL PLANE. The eccentric contraction builds length and strength simultaneously. Do it once per week only. On all other sessions this week, use standard SQUEEZE.',
    planeNote_pt: 'PLANO VERTICAL. A contracao excentrica constroi comprimento E forca simultaneamente. Faca apenas uma vez por semana. Nas outras sessoes desta semana, use o APERTAR padrao.',
    appNote: 'Contract fully to Level 3. Lower over 8 slow counts to Level 1 base. Release completely. This is the eccentric PUSH. Do not rush the descent. The slowness is the exercise.',
    appNote_pt: 'Contrair completamente ate o Nivel 3. Descer em 8 contagens lentas ate a base do Nivel 1. Soltar completamente. Esse e o EMPURRAR excentrico. Nao apresse a descida. A lentidao e o exercicio.',
  },

  {
    week: 4, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 8, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Isometric Hold at Level 3: can you sustain for 15 seconds without depth retreat?', pt: 'Hold Isometrico no Nivel 3: consegue sustentar por 15 segundos sem perder a profundidade?' },
        { en: 'Eccentric descent: does it feel distinct from a regular PUSH?', pt: 'Descida excentrica: parece distinto de um EMPURRAR regular?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 5, year: 2,
    theme: 'Lateral Plane: Aperto at All Three Levels (Target 20s Isometric)',
    theme_pt: 'Plano Lateral: Aperto nos Tres Niveis (Meta 20s Isometrico)',
    plane: 'lateral',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false,
    newMovement: 'Aperto L3', newMovement_pt: 'Aperto N3',
    freq: 5, color: '#9B4D7E',
    zone: 'Side walls 0-10cm', zone_pt: 'Paredes laterais 0-10cm',
    position: 'sitting',
    squeeze: { hold: 12, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    isometricTarget: 20,
    milestone: null,
    skillBadge: 'Aperto at Level 3',
    skillBadge_pt: 'Aperto no Nivel 3',
    exercises: ['aperto_l3'],
    planeNote: 'LATERAL PLANE. Three lateral compressions: Aperto at Level 1 (12s), Level 2 (12s), Level 3 (12s). The frontal plane of pompoir. Each level is a separate session focus.',
    planeNote_pt: 'PLANO LATERAL. Tres compressoes laterais: Aperto no Nivel 1 (12s), Nivel 2 (12s), Nivel 3 (12s). O plano frontal do pompoir. Cada nivel e um foco de sessao separado.',
    appNote: 'LATERAL PLANE week. Aperto at Level 1, Level 2, then Level 3 in sequence. Hold 12 seconds at each level. Also: continue isometric vertical hold at Level 3, target 20 seconds this week.',
    appNote_pt: 'Semana do PLANO LATERAL. Aperto no Nivel 1, Nivel 2, depois Nivel 3 em sequencia. Segurar 12 segundos em cada nivel. Tambem: continue o hold isometrico vertical no Nivel 3, meta de 20 segundos esta semana.',
  },

  {
    week: 6, year: 2,
    theme: 'Lateral Plane: Rajada Pattern at Level 1 (Bridge Week)',
    theme_pt: 'Plano Lateral: Padrao de Rajada no Nivel 1 (Semana de Transicao)',
    plane: 'lateral',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false,
    newMovement: 'Rajada Pattern', newMovement_pt: 'Padrao de Rajada',
    freq: 5, color: '#9B4D7E',
    zone: 'Side walls 0-3cm', zone_pt: 'Paredes laterais 0-3cm',
    position: 'sitting',
    squeeze: { on: 1, off: 1, sets: 4, reps: 20 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 4 },
    milestone: null,
    skillBadge: 'Rajada pattern established',
    skillBadge_pt: 'Padrao de Rajada estabelecido',
    exercises: ['rajada_l1_intro'],
    planeNote: 'LATERAL PLANE at speed. This is a bridge week: learn the Rajada rhythm at Level 1 before taking it to Level 2 next week. 1 second on, 1 second off, x20 reps x4 sets. Quality over quantity.',
    planeNote_pt: 'PLANO LATERAL em velocidade. Esta e uma semana de transicao: aprenda o ritmo da Rajada no Nivel 1 antes de leva-la ao Nivel 2 na proxima semana. 1 segundo ativado, 1 segundo solto, x20 rep x4 series. Qualidade sobre quantidade.',
    appNote: 'Rajada Lateral at Level 1 to learn the rhythm. 1 second on, 1 second off. Each rep starts fresh. No tension accumulating. Full lateral RELAX between every set. Next week: Level 2.',
    appNote_pt: 'Rajada Lateral no Nivel 1 para aprender o ritmo. 1 segundo ativado, 1 segundo solto. Cada rep comeca do zero. Sem tensao acumulando. RELAXAR lateral completo entre cada serie. Proxima semana: Nivel 2.',
  },

  {
    week: 7, year: 2,
    theme: 'Lateral Plane: Rajada at Level 2',
    theme_pt: 'Plano Lateral: Rajada no Nivel 2',
    plane: 'lateral',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false,
    newMovement: 'Rajada L2', newMovement_pt: 'Rajada N2',
    freq: 5, color: '#9B4D7E',
    zone: 'Side walls 3-6cm', zone_pt: 'Paredes laterais 3-6cm',
    position: 'sitting',
    squeeze: { on: 1, off: 1, sets: 6, reps: 40 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 3 },
    milestone: null,
    skillBadge: 'Rajada Lateral from Level 2',
    skillBadge_pt: 'Rajada Lateral do Nivel 2',
    exercises: ['rajada_l2'],
    planeNote: 'LATERAL PLANE at speed from Level 2. Now that the rhythm is established, bring it to depth. 1 second on, 1 second off, x40 reps x6 sets. Target: 3 per second.',
    planeNote_pt: 'PLANO LATERAL em velocidade do Nivel 2. Agora que o ritmo esta estabelecido, leve-o a profundidade. 1 segundo ativado, 1 segundo solto, x40 rep x6 series. Meta: 3 por segundo.',
    appNote: 'Rajada Lateral from Level 2. 1 second on, 1 second off, x40 reps x6 sets. Full lateral RELAX between every set. Breathe into the side walls. If depth retreats to Level 1, stop and rebuild from Level 2.',
    appNote_pt: 'Rajada Lateral do Nivel 2. 1 segundo ativado, 1 segundo solto, x40 rep x6 series. RELAXAR lateral completo entre cada serie. Respire para as paredes laterais. Se a profundidade recuar para o Nivel 1, pare e reconstrua do Nivel 2.',
  },

  {
    week: 8, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 8, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Rajada from Level 2: can you maintain depth for 20 reps without retreat?', pt: 'Rajada do Nivel 2: consegue manter a profundidade por 20 rep sem recuar?' },
        { en: 'Aperto at Level 3: does the lateral compression feel distinct from the basic SQUEEZE?', pt: 'Aperto no Nivel 3: a compressao lateral parece distinta do APERTAR basico?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 9, year: 2,
    theme: 'Sagittal Plane: Onda from Level 2 (Target 25s Isometric)',
    theme_pt: 'Plano Sagital: Onda do Nivel 2 (Meta 25s Isometrico)',
    plane: 'sagittal',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false,
    newMovement: 'Onda L2', newMovement_pt: 'Onda N2',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 12, sets: 4, reps: 12 },
    relax: { cycles: 10 },
    push: { hold: 5, reps: 10 },
    pushRule: 'direction_max_5s',
    isometricTarget: 25,
    milestone: null,
    skillBadge: 'Onda at Level 2',
    skillBadge_pt: 'Onda no Nivel 2',
    exercises: ['onda_l2'],
    planeNote: 'SAGITTAL PLANE. Front-back alternation from Level 2. The wave character changes at depth. Also continue isometric hold progression, target 25 seconds this week.',
    planeNote_pt: 'PLANO SAGITAL. Alternancia frente-fundo do Nivel 2. O carater da onda muda na profundidade. Tambem continue a progressao do hold isometrico, meta de 25 segundos esta semana.',
    appNote: 'SAGITTAL PLANE week. Onda from Level 2. Front wall at depth, release, back wall at depth, release. The wave feels different deeper inside. Also: isometric hold at Level 3, target 25 seconds.',
    appNote_pt: 'Semana do PLANO SAGITAL. Onda do Nivel 2. Parede frontal na profundidade, soltar, parede posterior na profundidade, soltar. A onda parece diferente mais profundo. Tambem: hold isometrico no Nivel 3, meta de 25 segundos.',
  },

  {
    week: 10, year: 2,
    theme: 'Sagittal Plane: Succao Anterior and Posterior at Level 3',
    theme_pt: 'Plano Sagital: Succao Anterior e Posterior no Nivel 3',
    plane: 'sagittal',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false,
    newMovement: 'Puxao Posterior', newMovement_pt: 'Puxao Posterior',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 6-10cm', zone_pt: 'Assoalho completo 6-10cm',
    position: 'sitting',
    squeeze: { hold: 12, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    sessionSplit: {
      sessionA: { exercises: ['succao'], label: 'Anterior sessions', label_pt: 'Sessoes anteriores' },
      sessionB: { exercises: ['puxao_posterior_l3'], label: 'Posterior sessions', label_pt: 'Sessoes posteriores' },
    },
    milestone: null,
    skillBadge: 'Sagittal plane: both anterior and posterior at Level 3',
    skillBadge_pt: 'Plano sagital: anterior e posterior no Nivel 3',
    exercises: ['succao', 'puxao_posterior_l3'],
    appNote: 'SAGITTAL PLANE deep. This week alternates: sessions 1, 3, 5 use anterior Succao. Sessions 2, 4 use posterior pull. Notice how the character of each differs at Level 3.',
    appNote_pt: 'PLANO SAGITAL profundo. Esta semana alterna: sessoes 1, 3, 5 usam Succao anterior. Sessoes 2, 4 usam puxao posterior. Perceba como o carater de cada um difere no Nivel 3.',
  },

  {
    week: 11, year: 2,
    theme: 'Rotational Plane: Circular at Level 2',
    theme_pt: 'Plano Rotacional: Circular no Nivel 2',
    plane: 'rotational',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false,
    newMovement: 'Circular L2', newMovement_pt: 'Circular N2',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 15, sets: 6, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    skillBadge: 'Circular at Level 2',
    skillBadge_pt: 'Circular no Nivel 2',
    exercises: ['circular_l2'],
    planeNote: 'ROTATIONAL PLANE. Circular clockwise and counterclockwise from Level 2. The spatial reference points shift when deeper. Move slowly. Three sets CW, three sets CCW.',
    planeNote_pt: 'PLANO ROTACIONAL. Circular horario e anti-horario do Nivel 2. Os pontos de referencia espacial mudam na profundidade. Mova-se devagar. Tres series horario, tres series anti-horario.',
    appNote: 'Circular clockwise from Level 2 x3 sets. Then counterclockwise from Level 2 x3 sets. Each step of the rotation must feel distinct even at depth.',
    appNote_pt: 'Circular horario do Nivel 2 x3 series. Depois anti-horario do Nivel 2 x3 series. Cada passo da rotacao deve ser distinto mesmo na profundidade.',
  },

  {
    week: 12, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 8, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Vertical plane: can you feel Level 3 distinctly in SQUEEZE, PUSH, and isometric hold?', pt: 'Plano vertical: consegue sentir o Nivel 3 claramente no APERTAR, EMPURRAR e hold isometrico?' },
        { en: 'Lateral plane: does Aperto at Level 3 feel different from Aperto at Level 1?', pt: 'Plano lateral: o Aperto no Nivel 3 parece diferente do Aperto no Nivel 1?' },
        { en: 'Sagittal plane: can you feel front wall and back wall as separate at Level 2?', pt: 'Plano sagital: consegue sentir a parede frontal e posterior como separadas no Nivel 2?' },
        { en: 'Rotational plane: does Circular feel distinct at Level 2 versus Level 1?', pt: 'Plano rotacional: o Circular parece distinto no Nivel 2 versus Nivel 1?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 13, year: 2,
    theme: 'All Planes in Supine: Isometric Target 30s',
    theme_pt: 'Todos os Planos em Supino: Meta Isometrica 30s',
    plane: 'all',
    phase: 'Mastery I', phase_pt: 'Maestria I',
    deload: false,
    newMovement: 'Supine Position', newMovement_pt: 'Posicao Supina',
    freq: 5, color: '#9B4D7E',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'supine',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    isometricTarget: 30,
    milestone: {
      checks: [
        { en: 'Isometric Hold at Level 3: 30 seconds without depth retreat?', pt: 'Hold Isometrico no Nivel 3: 30 segundos sem perder a profundidade?' },
        { en: 'All planes accessible in supine: vertical, lateral, sagittal, rotational?', pt: 'Todos os planos acessiveis em supino: vertical, lateral, sagital, rotacional?' },
      ]
    },
    skillBadge: 'All planes in supine. Isometric 30 seconds at Level 3.',
    skillBadge_pt: 'Todos os planos em supino. Isometrico 30 segundos no Nivel 3.',
    exercises: ['isometrico_l3', 'aperto_l3', 'onda_l2', 'circular_l2'],
    appNote: 'All four planes lying on your back. Gravity-assisted drop makes RELAX more passive. The vertical plane feels lighter. The lateral and sagittal planes feel wider. Isometric target this week: 30 seconds.',
    appNote_pt: 'Todos os quatro planos deitada de costas. A queda assistida pela gravidade torna o RELAXAR mais passivo. O plano vertical parece mais leve. Os planos lateral e sagital parecem mais largos. Meta isometrica desta semana: 30 segundos.',
  },

  // -- MASTERY II: Two-Plane Combinations -----------------------------

  {
    week: 14, year: 2,
    theme: 'Vertical + Lateral: SQUEEZE While APERTO',
    theme_pt: 'Vertical + Lateral: APERTAR Enquanto APERTO',
    plane: 'vertical_lateral',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false,
    newMovement: 'Combo: Vertical + Lateral', newMovement_pt: 'Combo: Vertical + Lateral',
    freq: 5, color: '#9B4D7E',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'supine',
    positionNote: 'Supine chosen for this first combination. Less gravitational demand allows full attention on coordinating two planes for the first time.',
    positionNote_pt: 'Supino escolhido para esta primeira combinacao. Menos demanda gravitacional permite atencao total na coordenacao de dois planos pela primeira vez.',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    skillBadge: 'Two planes active: vertical and lateral',
    skillBadge_pt: 'Dois planos ativos: vertical e lateral',
    exercises: ['combo_sq_aperto'],
    combo: { planes: ['vertical', 'lateral'], description: 'SQUEEZE upward (vertical) WHILE pressing side walls inward (lateral) simultaneously.' },
    appNote: 'SQUEEZE upward at Level 2 AND press the side walls inward (Aperto) at Level 2, both at the same time. Vertical lift and lateral compression simultaneously. Release both completely.',
    appNote_pt: 'APERTAR para cima no Nivel 2 E pressionar as paredes laterais para dentro (Aperto) no Nivel 2, os dois ao mesmo tempo. Elevacao vertical e compressao lateral simultaneamente. Soltar ambos completamente.',
  },

  {
    week: 15, year: 2,
    theme: 'Vertical + Lateral at Speed: Vibracao While Aperto',
    theme_pt: 'Vertical + Lateral em Velocidade: Vibracao Enquanto Aperto',
    plane: 'vertical_lateral',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false,
    newMovement: 'Combo: Vibracao + Aperto', newMovement_pt: 'Combo: Vibracao + Aperto',
    freq: 5, color: '#9B4D7E',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'supine',
    positionNote: 'Supine continues. Speed combinations need the reduced distraction of gravity to establish correctly.',
    positionNote_pt: 'Supino continua. Combinacoes em velocidade precisam da distancia reduzida da gravidade para se estabelecer corretamente.',
    squeeze: { on: 1, off: 1, sets: 4, reps: 20 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 3 },
    milestone: null,
    skillBadge: 'Vibracao while holding Aperto',
    skillBadge_pt: 'Vibracao enquanto segura Aperto',
    exercises: ['combo_vibracao_aperto'],
    combo: { planes: ['vertical', 'lateral'], description: 'Hold Aperto at Level 2 isometrically. While holding, fire Vibracao from Level 2.' },
    appNote: 'Establish Aperto at Level 2. Hold it. While holding, fire Vibracao at Level 2. The lateral compression stays constant while the vertical pulse fires. If Aperto drops when Vibracao starts, slow the speed down.',
    appNote_pt: 'Estabeleca o Aperto no Nivel 2. Segure. Enquanto segura, dispare a Vibracao no Nivel 2. A compressao lateral permanece constante enquanto o pulso vertical dispara. Se o Aperto cair quando a Vibracao comecar, diminua a velocidade.',
  },

  {
    week: 16, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'supine',
    squeeze: { hold: 8, sets: 2, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Can you hold Aperto lateral grip while firing any vertical movement?', pt: 'Consegue manter o grip lateral do Aperto enquanto dispara qualquer movimento vertical?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 17, year: 2,
    theme: 'Vertical + Sagittal: SQUEEZE While ONDA',
    theme_pt: 'Vertical + Sagital: APERTAR Enquanto ONDA',
    plane: 'vertical_sagittal',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false,
    newMovement: 'Combo: Vertical + Sagittal', newMovement_pt: 'Combo: Vertical + Sagital',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    positionNote: 'Returning to sitting here. The vertical-sagittal combination requires more spatial attention than vertical-lateral, and sitting provides better proprioceptive feedback for the sagittal axis.',
    positionNote_pt: 'Retornando ao sentado aqui. A combinacao vertical-sagital requer mais atencao espacial que a vertical-lateral, e o sentado oferece melhor feedback proprioceptivo para o eixo sagital.',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 8 },
    push: { hold: 5, reps: 8 },
    pushRule: 'direction_max_5s',
    milestone: null,
    skillBadge: 'Two planes: vertical and sagittal',
    skillBadge_pt: 'Dois planos: vertical e sagital',
    exercises: ['combo_sq_onda'],
    combo: { planes: ['vertical', 'sagittal'], description: 'SQUEEZE upward (vertical) WHILE Onda alternates front-back (sagittal).' },
    appNote: 'SQUEEZE and lift at Level 2. While lifted, fire Onda front-back from that same height. The vertical lift sustains. The sagittal wave moves inside it. Two different directions active at once.',
    appNote_pt: 'APERTAR e elevar no Nivel 2. Enquanto elevado, dispare a Onda frente-fundo dessa mesma altura. A elevacao vertical sustenta. A onda sagital se move dentro dela. Duas direcoes diferentes ativas ao mesmo tempo.',
  },

  {
    week: 18, year: 2,
    theme: 'Lateral + Sagittal: Aperto While ONDA',
    theme_pt: 'Lateral + Sagital: Aperto Enquanto ONDA',
    plane: 'lateral_sagittal',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false,
    newMovement: 'Combo: Lateral + Sagittal', newMovement_pt: 'Combo: Lateral + Sagital',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 15, sets: 4, reps: 12 },
    relax: { cycles: 8 },
    push: { hold: 5, reps: 8 },
    pushRule: 'direction_max_5s',
    milestone: null,
    skillBadge: 'Two planes: lateral and sagittal',
    skillBadge_pt: 'Dois planos: lateral e sagital',
    exercises: ['combo_aperto_onda'],
    combo: { planes: ['lateral', 'sagittal'], description: 'Hold Aperto (lateral grip) constant while Onda alternates front-back.' },
    appNote: 'This is true 3D movement. Hold Aperto constant. While holding, fire Onda front-back. Two different planes moving at the same time: one held, one alternating. If the Aperto collapses when Onda fires, reduce the Onda speed.',
    appNote_pt: 'Isso e movimento 3D verdadeiro. Mantenha o Aperto constante. Enquanto segura, dispare a Onda frente-fundo. Dois planos diferentes se movendo ao mesmo tempo: um mantido, um alternando. Se o Aperto colapsar quando a Onda disparar, reduza a velocidade da Onda.',
  },

  {
    week: 19, year: 2,
    theme: 'Torcao: Opposing Corners (Start at 5 Seconds)',
    theme_pt: 'Torcao: Cantos Opostos (Comecar em 5 Segundos)',
    plane: 'diagonal',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false,
    newMovement: 'Torcao', newMovement_pt: 'Torcao',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-6cm', zone_pt: 'Assoalho completo 0-6cm',
    position: 'sitting',
    squeeze: { hold: 5, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 6 },
    milestone: null,
    skillBadge: 'Torcao: opposing corner compression',
    skillBadge_pt: 'Torcao: compressao de cantos opostos',
    exercises: ['torcao'],
    planeNote: 'DIAGONAL PLANE. Front-left + back-right simultaneously. Then front-right + back-left simultaneously. Start at 5 seconds. Build to 8 seconds next week. The most spatially demanding movement in the program. Partial success counts.',
    planeNote_pt: 'PLANO DIAGONAL. Frente-esquerda + costas-direita simultaneamente. Depois frente-direita + costas-esquerda simultaneamente. Comece em 5 segundos. Construa ate 8 segundos na proxima semana. O movimento mais exigente espacialmente no programa. Sucesso parcial conta.',
    appNote: 'Torcao. Press front-left AND back-right simultaneously. Hold 5 seconds. Release. Then press front-right AND back-left. Hold 5 seconds. A diagonal twist inside the pelvic floor. It is subtle. Start slow.',
    appNote_pt: 'Torcao. Pressione frente-esquerda E costas-direita simultaneamente. Segure 5 segundos. Solte. Depois pressione frente-direita E costas-esquerda. Segure 5 segundos. Um torcao diagonal dentro do assoalho pelvico. E sutil. Comece devagar.',
  },

  {
    week: 20, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 8, sets: 2, reps: 6 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Vertical + lateral: can you hold Aperto while SQUEEZE is active?', pt: 'Vertical + lateral: consegue manter o Aperto enquanto o APERTAR esta ativo?' },
        { en: 'Lateral + sagittal: can you hold Aperto while Onda alternates?', pt: 'Lateral + sagital: consegue manter o Aperto enquanto a Onda alterna?' },
        { en: 'Torcao: can you feel two different corners versus one general squeeze?', pt: 'Torcao: consegue sentir dois cantos diferentes versus um apertar geral?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 21, year: 2,
    theme: 'Torcao at 8 Seconds + Torcao While Ordenha',
    theme_pt: 'Torcao em 8 Segundos + Torcao Enquanto Ordenha',
    plane: 'diagonal_vertical',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false,
    newMovement: 'Torcao + Ordenha', newMovement_pt: 'Torcao + Ordenha',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'sitting',
    squeeze: { hold: 8, sets: 4, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 4, reps: 8 },
    pushRule: 'wave_4s_per_level',
    milestone: null,
    skillBadge: 'Torcao while Ordenha ascends',
    skillBadge_pt: 'Torcao enquanto Ordenha sobe',
    exercises: ['torcao', 'torcao_ordenha'],
    appNote: 'First 2 sets: Torcao at 8 seconds hold. Then 2 sets: hold Torcao while Ordenha ascends through it. The diagonal is held static. The ascending wave moves through it. Release all planes simultaneously at the top.',
    appNote_pt: 'Primeiras 2 series: Torcao a 8 segundos de hold. Depois 2 series: mantenha a Torcao enquanto a Ordenha sobe por ela. A diagonal e mantida estatica. A onda ascendente se move atraves dela. Solte todos os planos simultaneamente no topo.',
  },

  {
    week: 22, year: 2,
    theme: 'Two-Plane Review: All Four Combinations',
    theme_pt: 'Revisao Dois Planos: Todas as Quatro Combinacoes',
    plane: 'all',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 3-10cm', zone_pt: 'Assoalho completo 3-10cm',
    position: 'sitting',
    squeeze: { hold: 15, sets: 4, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 8 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
    exercises: ['combo_sq_aperto', 'combo_aperto_onda', 'combo_sq_onda', 'torcao'],
    appNote: 'All four two-plane combinations in sequence. Vertical + Lateral. Lateral + Sagittal. Vertical + Sagittal. Diagonal. Full RELAX from Level 2 between each combination. This review confirms readiness for Canal Lock.',
    appNote_pt: 'Todas as quatro combinacoes de dois planos em sequencia. Vertical + Lateral. Lateral + Sagital. Vertical + Sagital. Diagonal. RELAXAR completo do Nivel 2 entre cada combinacao. Esta revisao confirma a prontidao para o Bloqueio de Canal.',
  },

  {
    week: 23, year: 2,
    theme: 'Canal Lock: All Planes Compound',
    theme_pt: 'Bloqueio de Canal: Todos os Planos Compostos',
    plane: 'multiplanar',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false,
    newMovement: 'Canal Lock Full Speed', newMovement_pt: 'Bloqueio de Canal Velocidade Total',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'sitting',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 8 },
    push: { hold: 4, reps: 8 },
    pushRule: 'wave_4s_per_level',
    milestone: null,
    skillBadge: 'Canal Lock: all planes at all three levels',
    skillBadge_pt: 'Bloqueio de Canal: todos os planos nos tres niveis',
    exercises: ['canal_lock_speed'],
    appNote: 'Canal Lock: Level 1 lateral and lift (vertical + lateral together), then Level 2 (add depth), then Level 3 compound (all planes, all levels). Under 8 seconds total. Then Ordenha descending as the release. This is the synthesis of all two-plane work.',
    appNote_pt: 'Bloqueio de Canal: Nivel 1 lateral e elevacao (vertical + lateral juntos), depois Nivel 2 (adicionar profundidade), depois Nivel 3 composto (todos os planos, todos os niveis). Menos de 8 segundos no total. Depois Ordenha descendente como soltura. Esta e a sintese de todo o trabalho de dois planos.',
  },

  {
    week: 24, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 8, sets: 3, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Canal Lock: can you reach Level 3 compound in under 8 seconds?', pt: 'Bloqueio de Canal: consegue chegar ao Nivel 3 composto em menos de 8 segundos?' },
        { en: 'Can you hold one plane active while a second plane operates independently?', pt: 'Consegue manter um plano ativo enquanto um segundo plano opera independentemente?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 25, year: 2,
    theme: 'Position: Standing, All Two-Plane Combos',
    theme_pt: 'Posicao: Em Pe, Todas as Combinacoes de Dois Planos',
    plane: 'all',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false,
    newMovement: 'Standing Position', newMovement_pt: 'Posicao Em Pe',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'standing',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    skillBadge: 'Standing: two-plane combinations',
    skillBadge_pt: 'Em pe: combinacoes de dois planos',
    exercises: ['combo_sq_aperto', 'combo_aperto_onda', 'combo_sq_onda'],
    appNote: 'All two-plane combinations in standing position. Maximum gravity load. Active effort needed to maintain Level 2 while coordinating two planes at once.',
    appNote_pt: 'Todas as combinacoes de dois planos em posicao em pe. Carga maxima de gravidade. Esforco ativo necessario para manter o Nivel 2 enquanto coordena dois planos ao mesmo tempo.',
  },

  {
    week: 26, year: 2,
    theme: 'Standing: Mastery II Closing Session',
    theme_pt: 'Em Pe: Sessao de Fechamento Maestria II',
    plane: 'all',
    phase: 'Mastery II', phase_pt: 'Maestria II',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 3-10cm', zone_pt: 'Assoalho completo 3-10cm',
    position: 'standing',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: {
      checks: [
        { en: 'Can you hold one plane while a second plane moves, in standing position?', pt: 'Consegue manter um plano enquanto um segundo plano se move, em posicao em pe?' },
        { en: 'Canal Lock: can you reach Level 3 compound and hold for 5 seconds without depth retreat?', pt: 'Bloqueio de Canal: consegue chegar ao Nivel 3 composto e segurar por 5 segundos sem recuo de profundidade?' },
        { en: 'Torcao: can you feel two distinct diagonal corners versus a general squeeze?', pt: 'Torcao: consegue sentir dois cantos diagonais distintos versus um apertar geral?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
    exercises: ['combo_vibracao_aperto', 'torcao', 'canal_lock_speed'],
    appNote: 'Mastery II closing session. Speed combination (Vibracao while Aperto), diagonal (Torcao), and multiplanar synthesis (Canal Lock): all in standing. This is the Mastery II graduation check.',
    appNote_pt: 'Sessao de fechamento da Maestria II. Combinacao em velocidade (Vibracao enquanto Aperto), diagonal (Torcao) e sintese multiplanar (Bloqueio de Canal): tudo em pe. Esta e a verificacao de graduacao da Maestria II.',
  },

  // -- MASTERY III: Three-Plane Full Coordination + Timing ------------

  {
    week: 27, year: 2,
    theme: 'Three Planes at Level 2: First Attempt',
    theme_pt: 'Tres Planos no Nivel 2: Primeira Tentativa',
    plane: 'all',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false,
    newMovement: 'Three-Plane L2', newMovement_pt: 'Tres Planos N2',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'standing',
    squeeze: { hold: 15, sets: 4, reps: 8 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    skillBadge: 'Three planes simultaneously at Level 2',
    skillBadge_pt: 'Tres planos simultaneamente no Nivel 2',
    exercises: ['triple_plane_l2'],
    combo: { planes: ['vertical', 'lateral', 'sagittal'], description: 'SQUEEZE upward (vertical) + Aperto inward (lateral) + Succao anterior draw-in (sagittal): all at Level 2 simultaneously.' },
    appNote: 'Week 27 goal: 3 reps at any quality. Three planes at once at Level 2: SQUEEZE upward, press side walls inward, draw front wall inward. Partial quality is complete success this week.',
    appNote_pt: 'Meta da Semana 27: 3 rep em qualquer qualidade. Tres planos ao mesmo tempo no Nivel 2: APERTAR para cima, pressionar paredes laterais para dentro, puxar parede frontal para dentro. Qualidade parcial e sucesso completo esta semana.',
  },

  {
    week: 28, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'standing',
    squeeze: { hold: 8, sets: 3, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Three planes simultaneously: can you feel all three even briefly, even partially?', pt: 'Tres planos simultaneamente: consegue sentir os tres, mesmo que brevemente, mesmo que parcialmente?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 29, year: 2,
    theme: 'Three Planes at Level 3: Deep Coordination',
    theme_pt: 'Tres Planos no Nivel 3: Coordenacao Profunda',
    plane: 'all',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false,
    newMovement: 'Three-Plane L3', newMovement_pt: 'Tres Planos N3',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 6-10cm', zone_pt: 'Assoalho completo 6-10cm',
    position: 'standing',
    squeeze: { hold: 15, sets: 4, reps: 8 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    skillBadge: 'Three planes simultaneously at Level 3',
    skillBadge_pt: 'Tres planos simultaneamente no Nivel 3',
    exercises: ['triple_plane_l3'],
    combo: { planes: ['vertical', 'lateral', 'sagittal'], description: 'Isometric Hold L3 (vertical) + Encaixe Lateral L3 (lateral) + Puxao Anterior L3 (sagittal): all simultaneously at Level 3.' },
    appNote: 'Same structure as Week 27 but at Level 3. Isometric Hold at Level 3, Deep Lateral Lock at Level 3, Anterior Pull at Level 3: all at the same time. This is full pompoir coordination: three planes, deepest ring.',
    appNote_pt: 'Mesma estrutura da Semana 27 mas no Nivel 3. Hold Isometrico no Nivel 3, Encaixe Lateral Profundo no Nivel 3, Puxao Anterior no Nivel 3: todos ao mesmo tempo. Isso e coordenacao pompoir completa: tres planos, anel mais profundo.',
  },

  {
    week: 30, year: 2,
    theme: 'Three-Plane Sequence: Level 2 Then Level 3',
    theme_pt: 'Sequencia Tres Planos: Nivel 2 Depois Nivel 3',
    plane: 'all',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'standing',
    squeeze: { hold: 15, sets: 3, reps: 8 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 6 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
    exercises: ['triple_plane_l2', 'triple_plane_l3'],
    appNote: 'Three planes at Level 2, then three planes at Level 3, then three planes at Level 2 as the closing set. Transitioning between levels while holding all three planes is the skill being built here.',
    appNote_pt: 'Tres planos no Nivel 2, depois tres planos no Nivel 3, depois tres planos no Nivel 2 como serie final. A transicao entre niveis enquanto mantem todos os tres planos e a habilidade que esta sendo construida aqui.',
  },

  {
    week: 31, year: 2,
    theme: 'Timing Module 1: Conscious Release',
    theme_pt: 'Modulo de Timing 1: Soltura Consciente',
    plane: 'timing',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false,
    newMovement: 'Timing: Release', newMovement_pt: 'Timing: Soltura',
    freq: 5, color: '#8A6A7A',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'sitting',
    positionNote: 'Dropping to sitting for all timing modules. Removing gravitational complexity allows full attention on the precision of timing, which is the entire point of these sessions.',
    positionNote_pt: 'Voltando ao sentado para todos os modulos de timing. Remover a complexidade gravitacional permite atencao total na precisao do timing, que e o objetivo inteiro dessas sessoes.',
    squeeze: { hold: 15, sets: 3, reps: 10 },
    relax: { cycles: 15 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    catiaModule: true,
    skillBadge: 'Conscious timing: deliberate release',
    skillBadge_pt: 'Timing consciente: soltura deliberada',
    exercises: ['aperta_solta_release'],
    appNote: 'This week trains the precision of RELEASE. Contract fully. Hold. Then release on a deliberate cue: a count, a breath, or a specific sensation. The moment of release is the skill. Practice: stay contracted, choose the exact moment to let go, then let go completely.',
    appNote_pt: 'Esta semana treina a precisao da SOLTURA. Contrair completamente. Segurar. Depois soltar em um sinal deliberado: uma contagem, uma respiracao ou uma sensacao especifica. O momento da soltura e a habilidade. Pratica: fique contraida, escolha o momento exato para soltar, depois solte completamente.',
  },

  {
    week: 32, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'sitting',
    squeeze: { hold: 8, sets: 2, reps: 6 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 33, year: 2,
    theme: 'Timing Module 2: Responsive Contraction',
    theme_pt: 'Modulo de Timing 2: Contracao Responsiva',
    plane: 'timing',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false,
    newMovement: 'Timing: Squeeze', newMovement_pt: 'Timing: Apertar',
    freq: 5, color: '#8A6A7A',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'sitting',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    catiaModule: true,
    skillBadge: 'Conscious timing: responsive contraction',
    skillBadge_pt: 'Timing consciente: contracao responsiva',
    exercises: ['aperta_solta_squeeze'],
    appNote: 'This week trains the timing of SQUEEZE as a response. Stay open and released. Then contract on a precise cue, not before and not after. The squeeze follows the signal. Practice: begin from full release, then contract the instant the cue arrives.',
    appNote_pt: 'Esta semana treina o timing do APERTAR como resposta. Permaneca aberta e solta. Depois contraia em um sinal preciso, nem antes nem depois. O apertar segue o sinal. Pratica: comece de soltura completa, depois contraia no instante em que o sinal chegar.',
  },

  {
    week: 34, year: 2,
    theme: 'Timing Module 3: The Aperta e Solta Sequence',
    theme_pt: 'Modulo de Timing 3: A Sequencia Aperta e Solta',
    plane: 'timing',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false,
    newMovement: 'Aperta e Solta', newMovement_pt: 'Aperta e Solta',
    freq: 5, color: '#8A6A7A',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'sitting',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    catiaModule: true,
    skillBadge: 'Aperta e Solta: full three-movement timing sequence',
    skillBadge_pt: 'Aperta e Solta: sequencia de timing dos tres movimentos',
    exercises: ['aperta_solta_full'],
    appNote: 'The complete sequence. RELAX to receive, open, allow. SQUEEZE to respond, engage, draw in. PUSH to complete, return, release again. Three movements, three moments, one fluid response on cue. This is the integration of everything the timing modules have trained.',
    appNote_pt: 'A sequencia completa. RELAXAR para receber, abrir, permitir. APERTAR para responder, engajar, atrair. EMPURRAR para completar, retornar, soltar novamente. Tres movimentos, tres momentos, uma resposta fluida no sinal. Esta e a integracao de tudo o que os modulos de timing treinaram.',
  },

  {
    week: 35, year: 2,
    theme: 'Position: Kneeling, Three Planes',
    theme_pt: 'Posicao: Ajoelhada, Tres Planos',
    plane: 'all',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false,
    newMovement: 'Kneeling Position', newMovement_pt: 'Posicao Ajoelhada',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: {
      checks: [
        { en: 'Three planes simultaneously at Level 2: 3 reps at any quality in kneeling position?', pt: 'Tres planos simultaneamente no Nivel 2: 3 rep em qualquer qualidade em posicao ajoelhada?' },
        { en: 'Aperta e Solta sequence: can you time each of the three movements on a distinct cue?', pt: 'Sequencia Aperta e Solta: consegue cronometrar cada um dos tres movimentos em um sinal distinto?' },
      ]
    },
    skillBadge: 'Kneeling: three-plane coordination',
    skillBadge_pt: 'Ajoelhada: coordenacao tres planos',
    exercises: ['triple_plane_l2', 'triple_plane_l3'],
    appNote: 'All three planes in kneeling position. Anterior tilt changes the RELAX character. More deliberate effort needed to drop from Level 2. The PUSH changes significantly here. Notice how each plane shifts in this position.',
    appNote_pt: 'Todos os tres planos em posicao ajoelhada. A inclinacao anterior muda o carater do RELAXAR. Mais esforco deliberado necessario para descer do Nivel 2. O EMPURRAR muda significativamente aqui. Perceba como cada plano muda nessa posicao.',
  },

  {
    week: 36, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'kneeling',
    squeeze: { hold: 8, sets: 2, reps: 6 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 37, year: 2,
    theme: 'Ring Isolation: Each Level Independent from Level 2',
    theme_pt: 'Isolamento dos Aros: Cada Nivel Independente do Nivel 2',
    plane: 'vertical',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false,
    newMovement: 'Ring Isolation', newMovement_pt: 'Isolamento dos Aros',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    skillBadge: 'Independent ring control from Level 2',
    skillBadge_pt: 'Controle independente dos aros do Nivel 2',
    exercises: ['ring_isolation'],
    appNote: 'Ring isolation this week. Contract ONLY Ring 2 (Level 2), hold it, keep Ring 3 neutral. Then contract ONLY Ring 3 (Level 3), keep Ring 2 as neutral as possible. Then hold Ring 2 AND fire Ring 3 in rapid pulses. Level 1 (Ring 1) is a neutral reference point only, not an active contraction target in Year 2.',
    appNote_pt: 'Isolamento dos aros esta semana. Contrair APENAS o Aro 2 (Nivel 2), segurando, manter o Aro 3 neutro. Depois contrair APENAS o Aro 3 (Nivel 3), manter o Aro 2 tao neutro quanto possivel. Depois manter o Aro 2 E disparar o Aro 3 em pulsos rapidos. O Nivel 1 (Aro 1) e apenas um ponto de referencia neutro, nao um alvo de contracao ativo no Ano 2.',
  },

  {
    week: 38, year: 2,
    theme: 'Ring Combination: Two Rings, One Free',
    theme_pt: 'Combinacao de Aros: Dois Aros, Um Livre',
    plane: 'vertical',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false,
    newMovement: 'Ring Combination', newMovement_pt: 'Combinacao de Aros',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    skillBadge: 'Two rings held, third ring free to vary',
    skillBadge_pt: 'Dois aros mantidos, terceiro aro livre para variar',
    exercises: ['ring_combination'],
    appNote: 'Hold Ring 2 (Level 2) contracted. Ring 3 (deepest) stays as neutral as you can keep it and pulses independently. Then hold Ring 3. Ring 2 pulses independently. The held ring stays constant while the free ring varies. This is the beginning of playing the rings like an instrument.',
    appNote_pt: 'Manter o Aro 2 (Nivel 2) contraido. O Aro 3 (mais profundo) fica tao neutro quanto possivel e pulsa independentemente. Depois manter o Aro 3. O Aro 2 pulsa independentemente. O aro mantido fica constante enquanto o aro livre varia. Este e o inicio de tocar os aros como um instrumento.',
  },

  {
    week: 39, year: 2,
    theme: 'Arousal State: Voluntary Control Across All Planes',
    theme_pt: 'Estado de Excitacao: Controle Voluntario em Todos os Planos',
    plane: 'all',
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: false,
    newMovement: 'Arousal Awareness', newMovement_pt: 'Consciencia na Excitacao',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    catiaModule: true,
    milestone: {
      checks: [
        { en: 'Can you describe how each plane changes when you are aroused?', pt: 'Consegue descrever como cada plano muda quando esta excitada?' },
        { en: 'Can you fire a voluntary contraction in arousal state?', pt: 'Consegue disparar uma contracao voluntaria no estado de excitacao?' },
      ]
    },
    skillBadge: 'Arousal state: voluntary control maintained',
    skillBadge_pt: 'Estado de excitacao: controle voluntario mantido',
    exercises: ['triple_plane_l2', 'aperta_solta_full'],
    appNote: 'Observation and awareness session. Notice how each plane feels different in arousal state. The orgasm reflex fires at 0.8-second intervals, the same rhythm as Vibracao. Voluntary control is the goal. Forcing is not the goal.',
    appNote_pt: 'Sessao de observacao e consciencia. Perceba como cada plano parece diferente no estado de excitacao. O reflexo do orgasmo dispara a intervalos de 0.8 segundos, o mesmo ritmo da Vibracao. O controle voluntario e o objetivo. Forcar nao e o objetivo.',
  },

  {
    week: 40, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery III', phase_pt: 'Maestria III',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'kneeling',
    squeeze: { hold: 8, sets: 2, reps: 6 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
  },

  // -- MASTERY IV: Full Pompoir in Context ----------------------------

  {
    week: 41, year: 2,
    theme: 'Full Pompoir Sequence: All Planes, All Levels',
    theme_pt: 'Sequencia Pompoir Completa: Todos os Planos, Todos os Niveis',
    plane: 'all',
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: false,
    newMovement: 'Full Pompoir Sequence', newMovement_pt: 'Sequencia Pompoir Completa',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling',
    squeeze: { hold: 15, sets: 3, reps: 3 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 6 },
    milestone: null,
    skillBadge: 'Full pompoir sequence: all planes, all levels',
    skillBadge_pt: 'Sequencia pompoir completa: todos os planos, todos os niveis',
    exercises: ['full_pompoir_sequence'],
    appNote: 'Complete sequence by plane. Vertical at L1, L2, L3 (Ordenha ascending). Lateral at L1, L2, L3 (Aperto layered). Sagittal at L1, L2, L3 (Onda to Succao). Rotational (Circular all levels). Canal Lock (all planes compound). Full RELAX from L2 between each block.',
    appNote_pt: 'Sequencia completa por plano. Vertical nos N1, N2, N3 (Ordenha ascendente). Lateral nos N1, N2, N3 (Aperto em camadas). Sagital nos N1, N2, N3 (Onda para Succao). Rotacional (Circular todos os niveis). Bloqueio de Canal (todos os planos compostos). RELAXAR completo do N2 entre cada bloco.',
  },

  {
    week: 42, year: 2,
    theme: 'The Opposing Principle',
    theme_pt: 'O Principio da Oposicao',
    plane: 'timing',
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: false,
    newMovement: 'Opposing Principle', newMovement_pt: 'Principio da Oposicao',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 12 },
    push: { hold: 8, reps: 8 },
    catiaModule: true,
    milestone: null,
    skillBadge: 'The Opposing Principle: RELAX to receive, SQUEEZE to respond',
    skillBadge_pt: 'Principio da Oposicao: RELAXAR para receber, APERTAR para responder',
    exercises: ['opposing_principle'],
    appNote: 'RELAX to receive. SQUEEZE to respond. PUSH to complete. The most intelligent use of the three movements. Stay in resting state 75% of the time. Use the movements deliberately for 25%. Awareness, not effort.',
    appNote_pt: 'RELAXAR para receber. APERTAR para responder. EMPURRAR para completar. O uso mais inteligente dos tres movimentos. Fique no estado de repouso 75% do tempo. Use os movimentos deliberadamente por 25%. Consciencia, nao esforco.',
  },

  {
    week: 43, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'kneeling',
    squeeze: { hold: 8, sets: 2, reps: 6 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 44, year: 2,
    theme: 'Functional Position: Full Three-Plane Pompoir',
    theme_pt: 'Posicao Funcional: Pompoir Tres Planos Completo',
    plane: 'all',
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: false,
    newMovement: 'Functional Position', newMovement_pt: 'Posicao Funcional',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling_straddling',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    skillBadge: 'Full pompoir in functional intimate position',
    skillBadge_pt: 'Pompoir completo em posicao intima funcional',
    exercises: ['full_pompoir_sequence', 'opposing_principle'],
    appNote: 'Full three-plane pompoir in kneeling straddling position. The most functional expression of everything built over two years. Vertical, lateral, sagittal, timing principle: all in this position.',
    appNote_pt: 'Pompoir de tres planos completo em posicao ajoelhada com pernas abertas. A expressao mais funcional de tudo construido ao longo de dois anos. Vertical, lateral, sagital, principio do timing: tudo nessa posicao.',
  },

  {
    week: 45, year: 2,
    theme: 'Be Bold 3D Movements 23-28: Deep Precision',
    theme_pt: 'Movimentos Be Bold 3D 23-28: Precisao Profunda',
    plane: 'all',
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: false,
    newMovement: 'Movements 23-28', newMovement_pt: 'Movimentos 23-28',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 6-10cm', zone_pt: 'Assoalho completo 6-10cm',
    position: 'kneeling_straddling',
    squeeze: { hold: 15, sets: 4, reps: 8 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null,
    skillBadge: 'Be Bold 3D Movements 23 to 28',
    skillBadge_pt: 'Movimentos Be Bold 3D 23 a 28',
    exercises: [
      'puxao_anterior_l3',
      'puxao_posterior_l3',
      'encaixe_lateral_l3',
      'circunferencial_l3',
      'sequencia_sagital_l3',
      'ordenha_aperto',
    ],
    sessionStructure: 'One movement per session across the five sessions this week. Movement 23 on session 1, Movement 24 on session 2, Movement 25 on session 3, Movement 26 on session 4, Movement 27 and 28 on session 5.',
    sessionStructure_pt: 'Um movimento por sessao nas cinco sessoes desta semana. Movimento 23 na sessao 1, Movimento 24 na sessao 2, Movimento 25 na sessao 3, Movimento 26 na sessao 4, Movimentos 27 e 28 na sessao 5.',
    appNote: 'Six new movements this week: Deep Anterior Pull (23), Deep Posterior Pull (24), Deep Lateral Lock at Level 3 (25), Full Circumferential at Level 3 (26), Deep Sagittal Sequence (27), Ordenha with Aperto (28). One per session.',
    appNote_pt: 'Seis novos movimentos esta semana: Puxao Anterior Profundo (23), Puxao Posterior Profundo (24), Encaixe Lateral Profundo no Nivel 3 (25), Circunferencial Completo no Nivel 3 (26), Sequencia Sagital Profunda (27), Ordenha com Aperto (28). Um por sessao.',
  },

  {
    week: 46, year: 2,
    theme: 'Be Bold 3D Movements 29-34: Full Multiplanar',
    theme_pt: 'Movimentos Be Bold 3D 29-34: Multiplanar Completo',
    plane: 'all',
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: false,
    newMovement: 'Movements 29-34', newMovement_pt: 'Movimentos 29-34',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling_straddling',
    squeeze: { hold: 15, sets: 4, reps: 8 },
    relax: { cycles: 6 },
    push: { hold: 8, reps: 6 },
    milestone: null,
    skillBadge: 'Be Bold 3D Movements 29 to 34',
    skillBadge_pt: 'Movimentos Be Bold 3D 29 a 34',
    exercises: [
      'onda_succao',
      'circular_l3',
      'bloqueio_respirado',
      'chicote',
      'torcao_ordenha',
      'oposicao_completa',
    ],
    sessionStructure: 'One or two movements per session across five sessions. Session 1: Movement 29. Session 2: Movement 30. Session 3: Movement 31. Session 4: Movement 32. Session 5: Movements 33 and 34.',
    sessionStructure_pt: 'Um ou dois movimentos por sessao nas cinco sessoes. Sessao 1: Movimento 29. Sessao 2: Movimento 30. Sessao 3: Movimento 31. Sessao 4: Movimento 32. Sessao 5: Movimentos 33 e 34.',
    appNote: 'Six movements: Onda with Succao (29), Circular at Level 3 (30), Breath Canal Lock (31), Chicote maximum speed (32), Torcao with Ordenha (33), Complete Opposition (34). One per session. Take your time with each.',
    appNote_pt: 'Seis movimentos: Onda com Succao (29), Circular no Nivel 3 (30), Bloqueio Respirado (31), Chicote velocidade maxima (32), Torcao com Ordenha (33), Oposicao Completa (34). Um por sessao. Leve seu tempo com cada um.',
  },

  {
    week: 47, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'kneeling_straddling',
    squeeze: { hold: 8, sets: 2, reps: 6 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Have you practiced all 34 Be Bold 3D movements at least once?', pt: 'Voce praticou todos os 34 movimentos Be Bold 3D ao menos uma vez?' },
        { en: 'Can you fire Ring 2 and Ring 3 independently?', pt: 'Consegue disparar o Aro 2 e o Aro 3 de forma independente?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 48, year: 2,
    theme: 'Ring Sequencing: Play the Instrument',
    theme_pt: 'Sequenciamento dos Aros: Toque o Instrumento',
    plane: 'vertical',
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: false,
    newMovement: 'Ring Sequencing', newMovement_pt: 'Sequenciamento dos Aros',
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling_straddling',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null,
    skillBadge: 'Ring sequencing: independent play of Rings 2 and 3',
    skillBadge_pt: 'Sequenciamento dos aros: jogo independente dos Aros 2 e 3',
    exercises: ['ring_isolation', 'ring_combination'],
    appNote: 'Ring 2 on. Ring 3 on. Ring 3 off. Ring 2 pulses alone. Ring 3 pulses alone. Ring 2 held while Ring 3 fires in rapid sequence. Create your own combinations. Rings 2 and 3 are now your instrument. Ring 1 is the neutral resting state between sequences.',
    appNote_pt: 'Aro 2 ativado. Aro 3 ativado. Aro 3 desativado. Aro 2 pulsa sozinho. Aro 3 pulsa sozinho. Aro 2 mantido enquanto Aro 3 dispara em sequencia rapida. Crie suas proprias combinacoes. Os Aros 2 e 3 sao agora o seu instrumento. O Aro 1 e o estado neutro de repouso entre as sequencias.',
  },

  {
    week: 49, year: 2,
    theme: 'Personal Assessment: Year 2',
    theme_pt: 'Avaliacao Pessoal: Ano 2',
    plane: 'all',
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling_straddling',
    squeeze: { hold: 15, sets: 4, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 8 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
    appNote: 'This is a map, not a test. Choose your three strongest movements. Then choose one from each plane (vertical, lateral, sagittal). Notice the difference between strength and coordination. Both are yours now.',
    appNote_pt: 'Isso e um mapa, nao um teste. Escolha seus tres movimentos mais fortes. Depois escolha um de cada plano (vertical, lateral, sagital). Perceba a diferenca entre forca e coordenacao. As duas sao suas agora.',
  },

  {
    week: 50, year: 2,
    theme: 'Recovery Week',
    theme_pt: 'Semana de Recuperacao',
    plane: null,
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: true, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#6A7A8A',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'kneeling_straddling',
    squeeze: { hold: 8, sets: 2, reps: 6 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
  },

  {
    week: 51, year: 2,
    theme: 'Two Years: Peak Session',
    theme_pt: 'Dois Anos: Sessao de Pico',
    plane: 'all',
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 5, color: '#4A1B6D',
    zone: 'Full floor 0-10cm', zone_pt: 'Assoalho completo 0-10cm',
    position: 'kneeling_straddling',
    squeeze: { hold: 15, sets: 3, reps: 10 },
    relax: { cycles: 10 },
    push: { hold: 8, reps: 6 },
    milestone: null, skillBadge: null, skillBadge_pt: null,
    exercises: ['full_pompoir_sequence', 'opposing_principle', 'ring_combination'],
    appNote: 'This is not a test. It is a celebration. Full sequence in your chosen position at your best quality. Three planes. Three rings. The timing principle. Everything you have built.',
    appNote_pt: 'Isso nao e um teste. E uma celebracao. Sequencia completa na posicao escolhida com a melhor qualidade. Tres planos. Tres aros. O principio do timing. Tudo o que voce construiu.',
  },

  {
    week: 52, year: 2,
    theme: 'Maintenance Design',
    theme_pt: 'Design de Manutencao',
    plane: 'all',
    phase: 'Mastery IV', phase_pt: 'Maestria IV',
    deload: false, newMovement: null, newMovement_pt: null,
    freq: 3, color: '#4A1B6D',
    zone: 'Full floor 3-6cm', zone_pt: 'Assoalho completo 3-6cm',
    position: 'kneeling_straddling',
    squeeze: { hold: 15, sets: 3, reps: 10 },
    relax: { cycles: 8 },
    push: { hold: 8, reps: 6 },
    milestone: {
      checks: [
        { en: 'Full sequence at Level 2: can you move through all planes without pausing to think?', pt: 'Sequencia completa no Nivel 2: consegue passar por todos os planos sem pausar para pensar?' },
        { en: 'Three planes simultaneously: accessible in any position?', pt: 'Tres planos simultaneamente: acessivel em qualquer posicao?' },
        { en: 'Rings 2 and 3 independently controllable?', pt: 'Aros 2 e 3 controlaveis de forma independente?' },
        { en: 'Maintenance programme designed?', pt: 'Programa de manutencao desenhado?' },
      ]
    },
    skillBadge: null, skillBadge_pt: null,
    maintenanceCard: true,
    appNote: 'Maintenance: 1 to 3 sessions per week. At minimum: one plane, one level, RELAX and PUSH in every session, always. Your body does not need fixing. It needs understanding. Now it understands.',
    appNote_pt: 'Manutencao: 1 a 3 sessoes por semana. No minimo: um plano, um nivel, RELAXAR e EMPURRAR em toda sessao, sempre. Seu corpo nao precisa de conserto. Precisa de compreensao. Agora ele compreende.',
  },

]
